// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivityConsumption_container__2Bddt"};